/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createEmptyStateResource } from '@common/tech-shared';
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ResourceUri } from '@ngxp/rest';
import { isUndefined } from 'lodash-es';
import { CommandOrder } from '../command.model';
import { buildCommandStateKey, COMMAND_FEATURE_KEY, CommandState } from './command.reducer';

const getCommandState: MemoizedSelector<object, CommandState> = createFeatureSelector<CommandState>(COMMAND_FEATURE_KEY);

const commandMap: MemoizedSelector<CommandState, any> = createSelector(
  getCommandState,
  (state: CommandState) => state.commandMap,
);

const command = (order: CommandOrder, uri: ResourceUri) =>
  createSelector(commandMap, (commandMapInState: any) =>
    isUndefined(commandMapInState[buildCommandStateKey(order, uri)]) ? createEmptyStateResource() : (
      commandMapInState[buildCommandStateKey(order, uri)]
    ),
  );

export const CommandSelectors = {
  getCommandState,
  commandMap,
  command,
};
